module.exports = __webpack_public_path__ + "img/nesting-dolls.100bcb35.svg";